var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevops(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2632 13.3359H7.12283C4.3092 13.3359 2.02832 15.6512 2.02832 18.5071V69.4856C2.02832 72.3415 4.3092 74.6567 7.12283 74.6567H21.2632C24.0768 74.6567 26.3577 72.3415 26.3577 69.4856V18.5071C26.3577 15.6512 24.0768 13.3359 21.2632 13.3359Z",
    stroke: "#243251",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1426 14.0171V73.8721C35.1426 74.3301 35.4434 74.7373 35.8847 74.8492L64.9476 82.891C66.863 83.4203 68.7484 81.9545 68.7484 79.9491V7.0951C68.7484 3.49159 65.1481 1.02822 61.8587 2.3719L35.7844 13.0704C35.4033 13.2231 35.1526 13.5998 35.1526 14.0171H35.1426Z",
    stroke: "#243251",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5137 8.22567V78.8504C77.5137 78.9319 77.5939 78.9725 77.6641 78.942L84.3732 75.2673V14.374C84.3732 14.1399 84.293 13.9159 84.1526 13.7429L79.2887 7.56398C78.687 6.80053 77.5137 7.2484 77.5137 8.2358V8.22567Z",
    stroke: "#243251",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/Devops.379c49b6cc71aec3de79475c5680f843.svg";
export { ForwardRef as ReactComponent };